import path from 'node:path';
import type { PluginOption } from 'vite';

const hash = Number(Date.now());

export const forceHashRefresh = (): PluginOption => {
  return {
    name: 'wix:force-hash-refresh',
    transform(code, id) {
      const extensions = new Set(['.ts', '.tsx', '.js', '.jsx', '.mjs']);
      const extension = path.extname(id);
      if (extensions.has(extension)) {
        const variables = ['import.meta.env.BASE_API_URL'];
        if (variables.some((variable) => code.includes(variable))) {
          return {
            code: `${code} \n\n/*! ENV_HASH:${hash} */`,
            map: null,
          };
        }
      }
      return null;
    },
  };
};
